import {track} from "@amplitude/analytics-browser";
import axios from "axios";
import React, {Suspense, useMemo, useState} from "react";
import { Canvas } from "react-three-fiber";
import {OrbitControls, useGLTF, useTexture} from "@react-three/drei";
import {ArrowRightOutlined, FullscreenOutlined, DownloadOutlined} from "@ant-design/icons";
import {Button, message} from "antd";
import {GLTFExporter} from "three/addons/exporters/GLTFExporter";
import {Mesh} from "three";
import {Spin} from "antd/es";

const ModelViewerTile = ({glbPath, bgColor, width, height,
                             showSelectButton, showFullScreen, showDownload,
                             onSelectTap, hoverShadow, texturePath,
                             downloadSize, setGlobalMesh, rotation, camera}) => {
    const color = bgColor == null ? "#464646" : bgColor;

    var link = document.createElement( 'a' );
    link.style.display = 'none';
    document.body.appendChild( link );
    const downloadModel = () => {
        const exporter = new GLTFExporter();
        const options = {};

        function save( blob, filename ) {

            link.href = URL.createObjectURL( blob );
            link.download = filename;
            link.click();

            // URL.revokeObjectURL( url ); breaks Firefox...

        }

        function saveString( text, filename ) {

            save( new Blob( [ text ], { type: 'model/gltf+json' } ), filename );

        }

        function downloadJSON( json, filename ) {

            saveString( JSON.stringify( json ), filename );

        }

        exporter.parse(
            mesh,
            function ( gltf ) {
                downloadJSON( gltf, "model.glb" );
            },
            function ( error ) {
                message.error("Failed to export");
            },
            options
        );
    }

    const [mesh, setMesh] = useState(null);

    const dwnSize = downloadSize === undefined ? "3rem" : downloadSize;

    let Model = (props) => {
        let { nodes, materials } = useGLTF(props.glbPath);
        let texturePath = props.texturePath === undefined ? "/3d-assets/texture/last_texture.png" : props.texturePath;
        let texture = useTexture(texturePath);

        let geom = {};
        for (let key in nodes) {
            if (key != "Scene") {
                geom = nodes[key]
            }
        }

        let mat = {};
        for (let key in materials) {
            if (key != "Scene") {
                mat = materials[key].clone();
            }
        }

        if (props.texturePath !== undefined) {
            texture.flipY = false;
            mat.map = texture;
        }

        if (mesh === null) {
            props.setMesh(new Mesh(geom.geometry, mat));
            if (setGlobalMesh !== undefined) {
                setGlobalMesh(new Mesh(geom.geometry, mat));
            }
        }

        return <group
            {...props}
            dispose={null}
            rotation={props.rotation}
            scale={[1, 1, 1]}
        >
            <mesh
                castShadow
                geometry={geom.geometry}
                material={mat}
            />
        </group>;
    }

    return (
        <div
            className={hoverShadow ? "shadow-md hover:shadow-dimensions-blue" : ""}
             style={{backgroundColor: color, width: width, height: height, borderRadius: 32, position: "relative"}}>
            <div style={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                { glbPath === null
                    ? <Spin size="large"/>
                    :
                    <Canvas pixelratio={[1, 2]} camera={camera} style={{width: "90%", height: "90%"}}>
                        <ambientLight intensity={1} />
                        <Suspense fallback={null}>
                            <Model glbPath={glbPath} texturePath={texturePath} setMesh={setMesh} rotation={rotation}/>
                        </Suspense>
                        <OrbitControls />
                    </Canvas>
                }
            </div>
            <Button
                hidden={!showSelectButton}
                type="primary"
                style={{backgroundColor: "#1890FF", width: 64, height: 64, borderRadius: "32px 0 32px 0", position: "absolute", bottom: 0, right: 0}}
                icon={<ArrowRightOutlined />}
                loading={glbPath === null}
                onClick={(e) => {
                    e.stopPropagation();
                    onSelectTap(glbPath);
                }}
            />

            <Button
                hidden={!showFullScreen}
                style={{width: "3rem", height: "3rem", position: "absolute", bottom: "1rem", left: "1rem", border: "none"}}
                icon={<FullscreenOutlined />}
                onClick={ (e) => {
                    // TODO
                }}
            />

            <Button
                hidden={!showDownload}
                style={{width: dwnSize, height: dwnSize, position: "absolute", bottom: "2rem", left: "2rem", border: "none"}}
                icon={<DownloadOutlined/>}
                onClick={ (e) => {
                    downloadModel();
                }}
            />

        </div>
    );
}

export default ModelViewerTile;